
import { useEffect,useState } from "react";
import DashboardContext from "./DashboardContext";
import { useNavigate } from "react-router-dom";
import { 
  AttachMoney, 
  AccountBalanceWallet, 
  SwapHoriz,  
 
} from "@mui/icons-material";
const DashboardProvider = ({ children }) => {
const [chartData, setChartData] = useState([]);
const navigate = useNavigate(); // Initialize navigation
const userData = sessionStorage.getItem("user");
const parsedData = userData ? JSON.parse(userData) : null;  // Ensure parsedData is not null

const sessionUser = parsedData?.AcntLst?.[0] || null; // Use optional chaining to prevent crashes





  // 🔹 Redirect to login if user is not found
  useEffect(() => {
    if (!sessionUser) {
      navigate("/login", { replace: true });
    }
  }, [sessionUser, navigate]);


    //Show downline list
    const [downlineData, setDownlineData] = useState([]);
    useEffect(() => {
      const fetchDownlines = async () => {
        try {
          const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/dashboard", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ComID: "EH25", Flag: "DOWNLINE",  UserID: sessionUser.UserID,
              ReferralID: sessionUser.Username,
              AuthCode: sessionUser.AuthCode,
              FiscalID:1 }),
          });
  
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
  
          const data = await response.json();
          setDownlineData(data.ProdLst || []);  
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      };
  
      fetchDownlines();
    }, []);


//show stats data
  const [statsData, setStatsData] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('https://testing.esnep.com/magnessa/api/vendor/dashboard', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ComID: 'EH25',  UserID: sessionUser.UserID,
            Flag: "COUNT",
            ReferralID: sessionUser.Username,
            AuthCode: sessionUser.AuthCode,FiscalID:1 }),
        });
  
        const result = await response.json();
        if (result.StatusCode === 200 && result.ProdLst && result.ProdLst.length > 0) {
          const d = result.ProdLst[0];
          setStatsData([
            { title: "Activation Period", value: d.ActivationPeriod ?? "Not Activated", icon: <AttachMoney />, change: "+12.3%", color: "#0ab39c" },
            { title: "Active PV", value: d.ActivePV ??0, icon: <AccountBalanceWallet />, change: "+8.1%", color: "#299cdb" },
            { title: "Expiry Date", value: d.ExpiryDate ??"Not Activated", icon: <SwapHoriz />, change: "-3.2%", color: "#f06548" },
            { title: "Total FOB", value: d.FOB??0, icon: <AttachMoney />, change: "-3.2%", color: "#f06548" },
            { title: "Total FOMB", value: d.FOMB ??0, icon: <AttachMoney />, change: "+12.3%", color: "#0ab39c" },
            { title: "Total TOB", value: d.TOB ??0, icon: <AttachMoney />, change: "+8.1%", color: "#299cdb" },
            { title: "Total FTB", value: d.FTB ??0, icon: <SwapHoriz />, change: "-3.2%", color: "#f06548" },
            { title: "Total PET", value: d.PETCount ??0, icon: <SwapHoriz />, change: "-3.2%", color: "#f06548" },
            { title: "Life Style Bonus", value: d.LifeStyleBonus ??0, icon: <AttachMoney />, change: "+12.3%", color: "#0ab39c" },
            { title: "Rank Bonus", value: d.RankAdvancementBonusCash ??0, icon: <AccountBalanceWallet />, change: "+8.1%", color: "#299cdb" },
            { title: "Total SUN Team", value: d.TeamSunCount ??0, icon: <SwapHoriz />, change: "-3.2%", color: "#f06548" },
            { title: "Total MOON Team", value: d.TeamMoonCount??0, icon: <SwapHoriz />, change: "-3.2%", color: "#f06548" },
          ]);
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
      }
    };
  
    fetchStats();
  }, []);



//for transaction data
  useEffect(() => {
    if (!sessionUser) return;
    const fetchTransactions = async () => {
      try {
        const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/dashboard", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ComID: "EH25",
            UserID: sessionUser.UserID,
            Flag: "TRANSACTION",
            ReferralID: sessionUser.Username,
            AuthCode: sessionUser.AuthCode,
            FiscalID: 1,
          }),
        });

        const data = await response.json();
        
        if (data.StatusCode === 200) {
          // Transform API response into the required chart format
          const formattedData = data.ProdLst.map(item => ({
            name: item.Month,
            uv: item.TransAmt,  // Sales Volume
            pv: item.TransAmt * 1.2, // Simulated Revenue (Example Multiplier)
          }));
          
          setChartData(formattedData);
        } else {
          console.error("API Error:", data.Message);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    fetchTransactions();
  }, []);



  //for earning data
  const [earningData, setEarningData] = useState([]);
  
  useEffect(() => {
    const fetchEarnings = async () => {
      try {
        const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/dashboard", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ComID: "EH25",
            UserID: sessionUser.UserID,
            Flag: "EARNING",
            ReferralID: sessionUser.Username,
            AuthCode: sessionUser.AuthCode,
            FiscalID: 1,
          }),
        });

        const data = await response.json();
        
        if (data.StatusCode === 200) {
          // Transform API response into the required chart format
          const formattedData = data.ProdLst.map(item => ({
            name: item.Month, // X-axis: Month Name
            uv: item.EarningAmt, // Actual Revenue
            pv: item.EarningAmt * 1.2, // Simulated Target Revenue (Example Multiplier)
          }));
          
          setEarningData(formattedData);
        } else {
          console.error("API Error:", data.Message);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    fetchEarnings();
  }, []);

// count of profile
const [pcountData, setPcountData] = useState({});
useEffect(() => {
  const fetchPcountData = async () => {
    try {
      const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/dashboard", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ComID: "EH25",
          UserID: sessionUser.UserID,
          Flag: "PCOUNT",
          ReferralID: sessionUser.Username,
          AuthCode: sessionUser.AuthCode,
          FiscalID: 1,
        }),
      });

      const data = await response.json();

      if (data.StatusCode === 200 && data.ProdLst?.length > 0) {
        setPcountData(data.ProdLst[0]); // Store the first object inside ProdLst
      } else {
        console.error("API Error:", data.Message);
      }
    } catch (error) {
      console.error("Error fetching PCount data:", error);
    }
  };

  fetchPcountData();
}, [sessionUser.UserID, sessionUser.Username, sessionUser.AuthCode]); // Use specific properties

  

  return (
    <DashboardContext.Provider value={{chartData,setChartData,earningData ,sessionUser,statsData,downlineData,pcountData  }}>
      {children}
    </DashboardContext.Provider>
  );
}

export default DashboardProvider;